"use strict";
exports.__esModule = true;
exports.geoValidatorHOC = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var isEqual_1 = tslib_1.__importDefault(require("lodash/isEqual"));
var react_intl_1 = require("react-intl");
var common_1 = require("./helpers/geoChart/common");
var sdk_ui_1 = require("@gooddata/sdk-ui");
function geoValidatorHOC(InnerComponent) {
    var ValidatorHOCWrapped = /** @class */ (function (_super) {
        tslib_1.__extends(ValidatorHOCWrapped, _super);
        function ValidatorHOCWrapped(props) {
            var _this = _super.call(this, props) || this;
            _this.isLocationMissing = false;
            _this.isMapboxTokenMissing = false;
            _this.errorMap = sdk_ui_1.newErrorMapping(props.intl);
            return _this;
        }
        ValidatorHOCWrapped.prototype.render = function () {
            this.initError();
            if (this.isMapboxTokenMissing) {
                return this.renderErrorComponent(sdk_ui_1.ErrorCodes.GEO_MAPBOX_TOKEN_MISSING);
            }
            if (this.isLocationMissing) {
                return this.renderErrorComponent(sdk_ui_1.ErrorCodes.GEO_LOCATION_MISSING);
            }
            return react_1["default"].createElement(InnerComponent, tslib_1.__assign({ key: "InnerComponent" }, this.props));
        };
        ValidatorHOCWrapped.prototype.shouldComponentUpdate = function (nextProps) {
            var _a = this.props, config = _a.config, execution = _a.execution, drillableItems = _a.drillableItems;
            var nextConfig = nextProps.config, nextExecution = nextProps.execution, nextDrillableItems = nextProps.drillableItems;
            // check if buckets, filters and config are changed
            var isSameConfig = this.isSameConfig(config, nextConfig);
            var isSameDataSource = this.isSameData(execution, nextExecution);
            var isSameDrillableItems = isEqual_1["default"](drillableItems, nextDrillableItems);
            return !isSameConfig || !isSameDataSource || !isSameDrillableItems;
        };
        ValidatorHOCWrapped.prototype.componentDidUpdate = function () {
            this.handleError();
        };
        ValidatorHOCWrapped.prototype.componentDidMount = function () {
            this.handleError();
        };
        ValidatorHOCWrapped.prototype.initError = function () {
            var _a, _b;
            var mapboxToken = (_b = (_a = this.props.config) === null || _a === void 0 ? void 0 : _a.mapboxToken) !== null && _b !== void 0 ? _b : "";
            var execution = this.props.execution;
            this.isLocationMissing = common_1.isLocationMissing(execution.definition.buckets);
            this.isMapboxTokenMissing = !mapboxToken;
        };
        ValidatorHOCWrapped.prototype.handleError = function () {
            var onError = this.props.onError;
            if (this.isLocationMissing) {
                onError === null || onError === void 0 ? void 0 : onError(new sdk_ui_1.GeoLocationMissingSdkError());
            }
            if (this.isMapboxTokenMissing) {
                onError === null || onError === void 0 ? void 0 : onError(new sdk_ui_1.GeoTokenMissingSdkError());
            }
        };
        ValidatorHOCWrapped.prototype.renderErrorComponent = function (errorState) {
            var _a;
            var ErrorComponent = (_a = this.props.ErrorComponent) !== null && _a !== void 0 ? _a : sdk_ui_1.ErrorComponent;
            // in this case, we show "Sorry, we can't display this insight"
            var errorProps = this.errorMap[errorState] || this.errorMap[sdk_ui_1.ErrorCodes.UNKNOWN_ERROR];
            return react_1["default"].createElement(ErrorComponent, tslib_1.__assign({ code: errorState }, errorProps));
        };
        ValidatorHOCWrapped.prototype.isSameConfig = function (config, nextConfig) {
            var colorMapping = ((config === null || config === void 0 ? void 0 : config.colorMapping) || []).map(function (currentColor) { return currentColor.color; });
            var nextColorMapping = ((nextConfig === null || nextConfig === void 0 ? void 0 : nextConfig.colorMapping) || []).map(function (newColor) { return newColor.color; });
            var configProps = tslib_1.__assign(tslib_1.__assign({}, config), { colorMapping: colorMapping });
            var nextConfigProps = tslib_1.__assign(tslib_1.__assign({}, nextConfig), { colorMapping: nextColorMapping });
            return isEqual_1["default"](configProps, nextConfigProps);
        };
        ValidatorHOCWrapped.prototype.isSameData = function (execution, nextExecution) {
            if (!execution || !nextExecution) {
                // one of data views is undefined. just test if the other one is also undefined, otherwise
                // data is definitely different
                return execution === nextExecution;
            }
            // we need equals here (not just fingerprint) for cases where measure is moved from one bucket to another
            return execution.equals(nextExecution);
        };
        return ValidatorHOCWrapped;
    }(react_1["default"].Component));
    var IntlValidatorHOC = react_intl_1.injectIntl(ValidatorHOCWrapped);
    return /** @class */ (function (_super) {
        tslib_1.__extends(ValidatorHOC, _super);
        function ValidatorHOC() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        ValidatorHOC.prototype.render = function () {
            return (react_1["default"].createElement(sdk_ui_1.IntlWrapper, { locale: this.props.locale },
                react_1["default"].createElement(IntlValidatorHOC, tslib_1.__assign({}, this.props))));
        };
        return ValidatorHOC;
    }(react_1["default"].Component));
}
exports.geoValidatorHOC = geoValidatorHOC;
//# sourceMappingURL=GeoValidatorHOC.js.map